<script>
  import { refreshDownloadUrl } from 'api/s3';
  import { isArrayBlank } from 'utils/array';
  import { isBlank, isNotBlank } from 'utils/string';

  export default {
    name: 'AttachmentPopoverTable',
    props: {
      fileList: {
        type: Array,
        required: false,
        default() {
          return [];
        },
      },
      fileBusinessType: {
        type: String,
        required: false,
        default: '',
      },
    },
    data() {
      return {
        refreshDownloadUrlLoading: false,
      };
    },
    methods: {
      isNotBlank,
      async handleRefreshDownloadLink() {
        this.refreshDownloadUrlLoading = true;
        const relatedNumber = this.fileList[0].relatedNumber;
        await refreshDownloadUrl({ relatedNumber })
          .then(() => {
            this.$message.success('刷新下载链接成功');
            this.$emit('refresh-list');
          })
          .catch(() => {
            this.$message.warning('刷新下载链接失败,请稍后再试');
          })
          .finally(() => {
            this.refreshDownloadUrlLoading = false;
          });
      },
      handleAttachmentsShow(fileList, type) {
        if (isArrayBlank(fileList)) {
          return [];
        }
        if (isBlank(type)) {
          return fileList;
        }
        let result = [];
        fileList.forEach((item) => {
          if (item.fileBusinessType === type) {
            result.push(item);
          }
        });
        return result;
      },
    },
  };
</script>

<template>
  <div
    v-if="
      fileList &&
        fileList.length > 0 &&
        handleAttachmentsShow(fileList, fileBusinessType).length > 0
    "
  >
    <el-popover trigger="hover">
      <el-button
        @click="handleRefreshDownloadLink()"
        style="margin-bottom: 10px"
        :loading="refreshDownloadUrlLoading"
        >刷新下载链接</el-button
      >
      <el-descriptions :column="1" border>
        <el-descriptions-item
          v-for="(file, index) in handleAttachmentsShow(fileList, fileBusinessType)"
          :key="index"
        >
          <template slot="label">
            {{ file.filename }}
          </template>
          <el-link
            v-if="isNotBlank(file.previewUrl)"
            type="primary"
            target="_blank"
            :href="file.previewUrl.replace(/^http:\/\//i, 'https://')"
            style="margin-right: 15px"
            >Preview
          </el-link>
          <el-link
            v-if="isNotBlank(file.downloadUrl)"
            type="primary"
            :href="file.downloadUrl.replace(/^http:\/\//i, 'https://')"
            :disabled="refreshDownloadUrlLoading"
            >Download</el-link
          >
        </el-descriptions-item>
      </el-descriptions>
      <el-link type="primary" slot="reference">附件列表</el-link>
    </el-popover>
  </div>
  <div v-else>
    <span />
  </div>
</template>

<style scoped lang="scss"></style>
